import EmbeddedAccountPayment from "./EmbeddedAccountPayment";
import {
  EapChooseMethod,
  EapConfirmBankPayment,
  EapPaymentFailed,
  EapProcessing,
  EapSuccess,
  EapChooseAmount,
} from "./sub-pages";
import RouterErrorBoundary from "../RouterErrorBoundary";

export const eapRoutes = {
  path: "/embeddedaccountpayment",
  element: <EmbeddedAccountPayment />,
  errorElement: <RouterErrorBoundary />,
  children: [
    {
      id: "eap-chooseamount",
      index: true,
      element: <EapChooseAmount />,
    },
    {
      id: "eap-choosepaymentmethod",
      path: "choosemethod",
      element: <EapChooseMethod />,
    },
    {
      id: "eap-confirmpaybybank",
      path: "confirmpaybybank",
      element: <EapConfirmBankPayment />,
    },
    {
      id: "eap-success",
      path: "success",
      element: <EapSuccess />,
    },
    {
      id: "eap-processing",
      path: "processing",
      element: <EapProcessing />,
    },
    {
      id: "eap-paymentfailed",
      path: "paymentfailed",
      element: <EapPaymentFailed />,
    },
  ],
};
